module.exports = __webpack_public_path__ + "static/media/Grupo 4920.fe4f19e2.png";